import { inject, Injectable, makeStateKey, TransferState } from '@angular/core';

import type { StoryblokClient } from '@storyblok/js';

@Injectable({
	providedIn: 'root',
})
export class StoryblokCacheVersionService {
	private readonly transferState = inject(TransferState);

	private cv: number | null = null;

	async ensureCv(
		sbClient: StoryblokClient,
		token: string,
		useTransferState: boolean,
	): Promise<number> {
		if (this.cv != null) return this.cv;

		const cvKey = makeStateKey<string>(`${token}/cv`);
		if (useTransferState) {
			const stored = this.transferState.get(cvKey, null);
			if (stored) {
				this.cv = JSON.parse(stored) as number;
				return this.cv;
			}
		}

		try {
			const res = await sbClient.get('cdn/spaces/me');
			const fetched = res?.data?.space?.version ?? Date.now();
			this.cv = fetched;

			if (useTransferState) {
				this.transferState.set(cvKey, JSON.stringify(fetched));
			}
			return fetched;
		} catch (e) {
			console.error('[Storyblok] get CV error:', e);
			this.cv = Date.now();
			return this.cv;
		}
	}
}
